import {resources, scopes} from '../../permissions/dictionary';
import {paths} from '../../dictionaries/urls';
import {filterByPermissions} from './helpers';

const accessoriesProcessOrders = [{
  'name': 'Combos y Tareas',
  'path': paths.ComboTasks,
  'resource': resources.ComboTasks,
  'scopes': [scopes.Create],
  'icon': 'related',
}, {
  'name': 'Facturación',
  'path': paths.AccessoriesInvoicing,
  'resource': resources.AccessoriesInvoicing,
  'scopes': [scopes.Create],
  'icon': 'invoicesDocuments',
}, {
  'name': 'Kanban Logística',
  'path': paths.KanbanLogistics,
  'resource': resources.KanbanLogistics,
  'scopes': [scopes.See],
  'icon': 'timeMarked',
}, {
  'name': 'Órdenes de Accesorios',
  'path': paths.AccessoriesOrders,
  'resource': resources.AccessoriesOrders,
  'scopes': [scopes.Create],
  'icon': 'order',
}, {
  'name': 'Órdenes PDS',
  'path': paths.AccessoriesOrdersPDS,
  'resource': resources.PDSOrders,
  'scopes': [scopes.Create],
  'icon': 'order',
}, {
  'name': 'Pedidos de Combos',
  'path': paths.SetsOrders,
  'resource': resources.SetsOrders,
  'scopes': [scopes.Create],
  'icon': 'setsOrders',
}, {
  'name': 'Marcado de Tiempos',
  'path': paths.TimeMarked,
  'resource': resources.TimeMarked,
  'scopes': [scopes.Create],
  'icon': 'timeMarked',
}];

const qualityAssuranceProcess = [
  {
    'name': 'Disponibilidad de Vehículos',
    'path': paths.VehiclesAvailability,
    'resource': resources.vehiclesAvailability,
    'scopes': [scopes.Edit],
    'icon': 'vehiclesAvailability',
  },
  {
    'name': 'Órdenes de Control Calidad',
    'path': paths.QualityControlAccessoriesOrdersList,
    'resource': resources.QualityAssuranceOrders,
    'scopes': [scopes.Create],
    'icon': 'order',
  },
  {
    'name': 'Facturación',
    'path': paths.QualityControlInvoicing,
    'resource': resources.QualityControlInvoicing,
    'scopes': [scopes.Create],
    'icon': 'invoicesDocuments',
  },
];

const devicesProcess = [{
  'name': 'Órdenes de Dispositivos',
  'path': paths.DevicesOrders,
  'resource': resources.DevicesOrders,
  'scopes': [scopes.See, scopes.Edit],
  'icon': 'order',
},
{
  'name': 'Stock Bodega',
  'path': paths.DevicesStock,
  'resource': resources.DevicesStock,
  'scopes': [scopes.See],
  'icon': 'partsMaster',
},
{
  'name': 'Reinstalación/Desinstalación',
  'path': paths.RequestsInstallationDevice,
  'resource': resources.RequestsInstallationDevice,
  'scopes': [scopes.See, scopes.Edit],
  'icon': 'order',
},
];

const accessoriesOutcomeReports = [{
  'name': 'Índices de Priorización',
  'path': paths.PrioritizationIndices,
  'resource': resources.PrioritizationIndicesReport,
  'scopes': [scopes.See],
  'icon': 'prioritizationIndices',
},
{
  'name': 'Índices de Logística',
  'path': paths.LogisticIndices,
  'resource': resources.LogisticIndicesReport,
  'scopes': [scopes.See],
  'icon': 'prioritizationIndices',
}];

const mantainingEnterProcess = [
  {
    'name': 'Áreas',
    'path': paths.LogisticAreas,
    'resource': resources.LogisticAreas,
    'scopes': [scopes.See, scopes.Edit],
    'icon': 'order',
  },
  {
    'name': 'Modelos',
    'path': paths.LogisticModels,
    'resource': resources.LogisticModels,
    'scopes': [scopes.See, scopes.Edit],
    'icon': 'order',
  },
  {
    'name': 'Tareas',
    'path': paths.LogisticTasks,
    'resource': resources.LogisticTasks,
    'scopes': [scopes.See, scopes.Edit],
    'icon': 'order',
  },
  {
    'name': 'Grupos Técnicos',
    'path': paths.TechniciansGroups,
    'resource': resources.TechniciansGroups,
    'scopes': [scopes.See, scopes.Edit],
    'icon': 'order',
  },
  {
    'name': 'Técnicos',
    'path': paths.Technicians,
    'resource': resources.Technicians,
    'scopes': [scopes.See, scopes.Edit],
    'icon': 'order',
  },
];

const getAccessoriesEnterOptions = (permissions) => {
  const options = [
    {
      'name': 'Mantenimiento',
      'options': filterByPermissions(permissions, mantainingEnterProcess),
    },
  ];
  return options.filter((item) => item.options.length);
};

const getAccessoriesProcessOptions = (permissions) => {
  const options = [{
    'name': 'Accesorios',
    'options': filterByPermissions(permissions, accessoriesProcessOrders),
  }, {
    'name': 'Control de Calidad',
    'options': filterByPermissions(permissions, qualityAssuranceProcess),
  }, {
    'name': 'Dispositivos',
    'options': filterByPermissions(permissions, devicesProcess),
  }];

  return options.filter((item) => item.options.length);
};

const getAccessoriesOutcomeOptions = (permissions) => {
  const options = [{
    'name': 'Reportes',
    'options': filterByPermissions(permissions, accessoriesOutcomeReports),
  }];

  return options.filter((item) => item.options.length);
};

export const getAccessoriesOptions = (permissions) => {
  const options = [{
    'name': 'Entrada',
    'options': getAccessoriesEnterOptions(permissions),
  },
  {
    'name': 'Proceso',
    'options': getAccessoriesProcessOptions(permissions),
  }, {
    'name': 'Salida',
    'options': getAccessoriesOutcomeOptions(permissions),
  }];

  return options.filter((item) => item.options.length);
};

export const accessoriesOptions = [
  ...accessoriesProcessOrders,
  ...qualityAssuranceProcess,
  ...accessoriesOutcomeReports,
  ...devicesProcess,
];
